// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"130":"3d65d994","297":"6f7c4143","537":"81ab1942","928":"028ce62d"}[chunkId] + ".css";
};